    <div class="w-100">
        <div class="page-info"><h3 style="margin: 25px; font-weight: 500; font-size:25px; color: #2a457a;">Book Receipt Details</h3></div>
        <div class="page-next"><mat-icon mat-list-icon style="padding: 1px;" routerLink="/tallyentry">arrow_circle_right</mat-icon></div>
      </div>
      

<div class="table-container" style="margin-left: 20px; margin-right: 20px;">
    <div class="w-100 border-p">
        <div class="mt-10 w-100 ">
            <!-- Financial Year -->
            <mat-form-field class="w-30 pl-20" appearance="outline">
                <mat-label class="custom-mat-label">Financial Year</mat-label>
                <mat-select matNativeControl required [(ngModel)]="l_bookNoformData.finyearmstId">
                    <mat-select-trigger>
                        {{ lFN_GetFinancialYearText(l_bookNoformData.finyearmstId) }}
                    </mat-select-trigger>
                    <mat-option *ngFor="let l_financialyear of l_financialYearList"
                        [value]="l_financialyear.finyearmstId">
                        <div class="option-container">
                            <span>{{ l_financialyear.finyear }}</span>
                            <ng-container *ngIf="l_financialyear.status">
                                <mat-icon class="active-icon">check_circle</mat-icon>
                            </ng-container>
                        </div>
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Category name -->
            <mat-form-field class="w-30 pl-20 " appearance="outline">
                <mat-label class="custom-mat-label">Txncategory</mat-label>
                <mat-select matNativeControl required [(ngModel)]="l_bookNoformData.txncategoryId">
                    <mat-option *ngFor="let l_category of l_categoryList" [value]="l_category.txncategoryId">
                        {{ l_category.name }}</mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Book Number -->
            <mat-form-field class="w-30 pl-20" appearance="outline">
                <mat-label class="custom-mat-label">Book Number</mat-label>
                <input matInput placeholder="Enter Book No" [(ngModel)]="l_bookNoformData.bookNo">
            </mat-form-field>

            <button mat-raised-button color="primary" class="custom-button-blue w-30 pl-20"
                style="margin-top: 4px; margin-left: 5px;" (click)="lFN_SearchBookReceipts()">Submit
            </button>
        </div>
    </div>

    <!-- total remain and completed -->
    <mat-chip-list class="justify-content">
        <mat-chip [ngClass]="{'matchips-cards': true}" style="margin-left: 9px; margin-bottom: 20px; margin-top: 20px;">
            <mat-label style="color: aliceblue;">Completed entries: {{ l_entriesDone }}</mat-label>
        </mat-chip>
        <mat-chip [ngClass]="{'matchips-cards': true}" style="margin-left: 9px; margin-bottom: 20px; margin-top: 20px;">
          <mat-label style="color: aliceblue;">Remaining entries: {{ l_entriesRemaining }}</mat-label>
        </mat-chip>
    </mat-chip-list>

    <!-- receipts -->
    <div class="w-100 border-p mt-10 justify-content" style="padding: 15px;">
        <mat-chip-list class="justify-content">
            <mat-chip *ngFor="let receipts of l_receiptsDetails" class="w-10 bg-color"
                style="padding: 15px; justify-content: center;margin: 5px 10px 2px 10px;align-items: center;"
                [ngClass]="{'active-receipts': receipts.status === true, 'inactive-receipts': receipts.status == false}">
                {{ receipts.receiptNo }}
            </mat-chip>
        </mat-chip-list>
    </div>

</div>